import { SalesChannelCategoryMappingListPage } from "@/features/sales-channel-category-mapping/pages/SalesChannelCategoryMappingListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-channel-category-mapping/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["masterdata.lookup"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryMappingListPage,
});
